"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const net_1 = require("net");
const tls_1 = require("tls");
const zlib = require("zlib");
/**
 * TODO: reject on promises on timeout
 * TODO: support compression (doesn't yet work)
 */
class Connection {
    constructor(host, port, tlsPort, tlsOptions) {
        this.connect = () => {
            this._socket = net_1.createConnection(this._port, this._host);
            this._addSocketHandlers();
            return this._tlsPort ? this.upgradeTls() : Promise.resolve(this._socket);
        };
        this.disconnect = () => {
            // Close connection
            this._socket.end();
            this._socket.destroy();
            this._socket.removeAllListeners();
            this._socket.unref();
            if (this._tlsPromiseReject) {
                this._tlsPromiseReject();
            }
            // Empty the queue
            this._queue.forEach(h => h.reject(new Error('Disconnected from server')));
            this._queue = [];
        };
        this.write = (str) => {
            if (this._compress) {
                str = zlib.deflateSync(str).toString('base64');
            }
            this._socket.write(str, 'UTF8');
        };
        this.addCallback = (callback, resolve, reject) => {
            this._queue.push({ callback, resolve, reject });
        };
        this.upgradeTls = () => new Promise((resolve, reject) => {
            this._tlsPromiseReject = reject;
            this._socket = tls_1.connect(Object.assign({}, this._tlsOptions, { socket: this._socket }), // tslint:disable-line
            () => {
                this._tlsPromiseReject = undefined;
                resolve(this._socket);
            });
            this._addSocketHandlers();
        });
        this.enableCompression = () => {
            this._compress = 'deflate';
            /* tslint:disable:no-console */
            this._socket.on('drain', () => console.log('drain'));
            this._socket.on('end', () => console.log('end'));
            this._socket.on('lookup', () => console.log('lookup'));
            this._socket.on('timeout', () => console.log('timeout'));
            /* tslint:enable:no-console */
        };
        this._handler = (frame) => {
            if (this._compress) {
                frame = zlib.inflateSync(Buffer.from(frame)).toString();
            }
            this._frames += frame;
            const responseHandler = this._queue[0];
            let response;
            try {
                response = responseHandler.callback(this._frames);
            }
            catch (err) {
                // TODO: remove console.error method
                // tslint:disable-next-line
                console.error('Fatal parse error, terminating connection', err);
                this.disconnect();
                return;
            }
            if (!response) {
                return;
            }
            this._frames = this._frames.slice(response._i);
            this._queue.shift();
            delete response._i;
            responseHandler.resolve(response);
            // Handle pipelined responses sent in single frame
            if (this._frames !== '') {
                this._handler('');
            }
        };
        this._addSocketHandlers = () => {
            this._socket.on('data', this._handler);
            this._socket.on('error', err => {
                this._queue.forEach(h => h.reject(err));
                this.disconnect();
                throw err;
            });
            this._socket.on('end', () => {
                const err = new Error('Received FIN packet from server, closing connection automatically');
                this._queue.forEach(h => h.reject(err));
                this.disconnect();
            });
            this._socket.on('tlsClientError', err => {
                this._queue.forEach(h => h.reject(err));
                this.disconnect();
                throw err;
            });
            this._socket.once('close', () => {
                this._queue.forEach(h => h.reject(new Error('Connection closed')));
                this._socket.removeAllListeners();
            });
        };
        this._host = host;
        this._port = port;
        this._tlsPort = tlsPort;
        this._tlsOptions = tlsOptions;
        this._queue = [];
        this._frames = '';
        this._compress = undefined;
    }
}
exports.default = Connection;
//# sourceMappingURL=Connection.js.map